import React, { useEffect, useState } from "react";
import yesIcon from "../../images/YES.svg";
import noIcon from "../../images/NO.svg";
import { Grid, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import { isEmpty, range } from "lodash";
import Draggable from "react-draggable";
import "animate.css/animate.css";


const GDPDroppable = (props) => {
  const {
    aref,
    title,
    inAnswer,
    getAnswers,
    currentAnswer,
    ifAnswer,
    classes,
    onDragEnd,
    onDragUpdate,
    isEvaluatorModalOpen,
    dragStarted,
    setDragStarted,
    isPreview,
    answered,
    showAnimation,
    moveBack,
    boxTitle
  } = props;
  const [animatingIndex, setAnimatingIndex] = useState(-1);
  const [targetPosition, setTargetPosition] = useState({ x: 0, y: 0 });
  const [movedItems, setMovedItems] = useState([]);

useEffect(() => {
    if(moveBack){
      startAnimation()
    }
  }, [moveBack])

  const calculateTargetPosition = (idx) => {
    const targetElement = document.querySelector('#draggable-container');
    const sourceElement = document.querySelector(`#img-${idx}`);
    
    if (targetElement && sourceElement) {
      const targetRect = targetElement.getBoundingClientRect();
      const sourceRect = sourceElement.getBoundingClientRect();
      
      // Calculate center points
      return {
        x: targetRect.left - sourceRect.left + (targetRect.width / 2) - (sourceRect.width / 2),
        y: targetRect.top - sourceRect.top + (targetRect.height / 2) - (sourceRect.height / 2)
      };
    }
    return { x: 0, y: 0 };
  };

  const returnImage = (icon, idx) => {
    if(movedItems.includes(idx)) {
      return <Grid className={classes.droppableCircle} style={{ marginTop: 0 }}/>;
    }
    console.log("returnImage", animatingIndex, idx, title)

    return title === "yes" ? img1(icon, idx) : img2(icon, idx)

    // return (
    //   <img 
    //     alt="answer"
    //     id={`img-${idx}`}
    //     src={icon} 
    //     style={newStyle}
    //     onAnimationEnd={(e) => console.log("onAnimationEnd")}
    //     onTransitionEnd={(e) => {
    //       console.log("onTransitionEnd1", idx)
    //       if (animatingIndex === idx) {
    //         setMovedItems(prev => [...prev, idx]);
    //         const totalItems = getAnswers(title).slice(0,8).length;
    //         if (idx === totalItems - 1) {
    //           console.log("onTransitionddEnd2", idx)
    //           // debugger
    //           // if(title === "yes"){
    //           //   props.setIsYesFinished(true);
    //           // }
    //           // else{
    //             // props.setprops.AnimationFinished(true);
    //           // }
    //         } else {
    //           setAnimatingIndex(idx + 1);
    //         }
    //       }
    //     }}
    //   />
    // )
  };

  const img1 = (icon,  idx) => {
    console.log("idx", idx)
    const baseDuration = 0.3;
    const minDuration = 0.1;
    const duration = Math.max(
      baseDuration - (idx * 0.1),
      minDuration
    );
    return (
      <img 
        alt="answer"
        id={`img-${idx}`}
        src={icon} 
        style={{
          width: '100%',
          transform: animatingIndex === idx ?
            `translate(${targetPosition.x}px, ${targetPosition.y}px)` : null,
          transition: animatingIndex === idx
            ? `transform ${duration}s cubic-bezier(0.1, 0, 0.9, 0.1)` // Movement for first question set
            : null,
          visibility: movedItems.includes(idx) ? 'hidden' : 'visible',
          position: 'relative',
          zIndex: animatingIndex === idx ? 999 : 1,
        }}
        onTransitionEnd={(e) => {
          console.log("onTransitionEnd1", idx)
          if (animatingIndex === idx) {
            setMovedItems(prev => [...prev, idx]);
            const totalItems = getAnswers(title).slice(0,7).length;
            if (idx === totalItems - 1) {
                console.log("onTransitionddEnd2", idx)
                props.setAnimationFinished(true);
            } else {
              setAnimatingIndex(idx + 1);
            }
          }
        }}
      />
    )
  }

  const img2 = (icon,  idx) => {
    return (
      <img 
        alt="answer"
        id={`img-${idx}`}
        src={icon}
        // className={`animate__animated ${moveBack && 'animate__fadeOut animate__delay-0.5s' }`}
        // onAnimationEnd={(e) => {
        //   setMovedItems(prev => [...prev, idx]);
        //   props.setIsNoFinished(true);
        // }}
        style={{
          width: '100%',
          transition: `opacity 0.1s ease-in-out`, // Fade out animation
          visibility: movedItems.includes(idx) ? 'hidden' : 'visible',
          position: 'relative',
          zIndex: animatingIndex === idx ? 999 : 1,
        }}
      />
    )
  }

  const startAnimation = () => {
    setAnimatingIndex(0);
    setMovedItems([]); // Reset moved items
  };

  useEffect(() => {
    if(animatingIndex !== -1){
      const position = calculateTargetPosition(animatingIndex);
      setTargetPosition(position);
    }
  },[animatingIndex])

  let index = getAnswers(title).length;

  const onDragStart = () => setDragStarted(true);

  const renderRemainingOptions = () => {
    let newIndex = index > 3 ? (answered && currentAnswer?.answer === title) ? 4 : 3 : index
    // if (dragStarted && index > 8) return <Grid className={classes.droppableCircle} style={{ zIndex: -1 }}/>
    // if (index > 8) new

    if (inAnswer)
      return range(4 - newIndex).map(() => (
        <Grid className={classes.droppableAnswer} />
      ));
    return range(4 - newIndex).map(() => (
      <Grid className={classes.droppableCircle} />
    ));
  };

  const renderDraggableAnswer = () => {
    if (currentAnswer?.answer === title) {
      if (!dragStarted) index += 1;
      // <Grid className={classes.droppableCircle} />
      // if (index > 8) return
      return (
        <div style={{ position: "relative" }}>
          <Draggable
            onDrag={onDragUpdate}
            onStart={onDragStart}
            onStop={(e) => onDragEnd(e, () => setDragStarted(false))}
            position={{ x: 0, y: 0 }}
          >
            {!dragStarted ? (
              <Grid
                className={classes.droppableAnswer}
                style={{ cursor: "pointer" }}
              >
                <img src={currentAnswer.imgSrc} width="100%" />
              </Grid>
            ) : (
              <Grid
                container
                alignItems="center"
                className={classes.innerDroppableElement}
              >
                <img
                  id="answer-icon"
                  src={currentAnswer.imgSrc}
                  className={classes.questionImg}
                />
                <Grid>
                  <Typography className={classes.serviceTitle}>
                    {currentAnswer.title}
                  </Typography>
                  <Typography className={classes.serviceDesc}>
                    {currentAnswer.desc}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Draggable>
          {/* </Grid> */}
          </div>
      );
    }
  };

  const renderAnswers = () => {
    let answers = getAnswers(title)
    const lastAnswer = answers.splice(-1)
    console.log("(isPreview && indexn >  7)",inAnswer,index, isPreview, (isPreview && index >  7))
    const newIndex = (answered && index >  3 && currentAnswer?.answer === title) ? 2 : index >= 3 ? 2 : index
    return (
      <>
        { console.log("answers1", answers.length, answers, newIndex) }
        {answers.slice(0,newIndex).map((answer, idx) => (
          <Grid className={classes.droppableAnswer}>
            {!inAnswer && returnImage(answer.icon, idx)}
          </Grid>
        ))}
        {lastAnswer[0] &&
          <Grid className={classes.droppableAnswer}>
            {
              console.log("answers.lengthd", answers.length, !inAnswer)
            }
          {!inAnswer && returnImage(lastAnswer[0].icon, index > 2 ? 2 : answers.length)}
        </Grid>}
      </>
    );
  };

  console.log('answered && inAnswer', answered , inAnswer)

  return (
    <Grid className={`${classes.draggableDrop} animate__animated ${moveBack && title === "no" && 'animate__fadeOut animate__slow' }`} ref={aref}
      // style={{ display: title === 'no' && 'none' }}
      onAnimationEnd={(e) => {
        // setMovedItems(prev => [...prev, idx]);
        title === "no" && props.setIsNoFinished(true);
      }}
    >
      <Grid
        container
        alignItems="center"
        className={classes.answerTitleContainer}
      >
        {/* <img
          src={title === "yes" ? yesIcon : noIcon}
            className={classes.answerTitleIcon}
        /> */}
        <Typography className={classes.answerTitleText}>
          {title}
          {/* {`${
            title === "yes"
              ? `${boxTitle}`
              : `${boxTitle}`
          }`} */}
        </Typography>
      </Grid>
      <Grid
        container
        justify="space-evenly"
        className={classes.answerDescContainer}
        style={{ [inAnswer && "backgroundColor"]: "#1db2d7", position: 'relative' }}
      >
        {renderAnswers()}
        {renderDraggableAnswer()}
        {renderRemainingOptions()}
        {index > 3 && !(currentAnswer?.answer === title) && !inAnswer && !(answered && inAnswer) &&
        <Typography className={`animate__animated ${classes.notificationText} ${moveBack ? 'animate__fadeOut animate__slow' : 'hello'}`}>+{index - 3}</Typography>
        }
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(GDPDroppable);
